import {TypedUseSelectorHook, useSelector} from 'react-redux';

import {WikiState} from '~ui/store';

export const useStateSelector: TypedUseSelectorHook<WikiState> = useSelector;
